import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Contact from '@/components/Contact'
import Corporatif from '@/components/Corporatif'
import Medias from '@/components/Medias'
import Particulier from '@/components/Particulier'
import ReparationModule from '@/components/ReparationModule'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path:"/",
            redirect: {
                name : "Home"
            }
        },
        {
            path: '/home',
            name: 'Home',
            component: Home
        },
        {
            path: '/contact',
            name: 'Contact',
            component: Contact
        },
        {
            path: '/corporatif',
            name: 'Corporatif',
            component: Corporatif
        },
        {
            path: '/medias',
            name: 'Medias',
            component: Medias
        },
        {
            path: '/particulier',
            name: 'Particulier',
            component: Particulier
        },
        {
            path: '/module-en-reparation',
            name: 'ReparationModule',
            component: ReparationModule
        }
    ]
})
